import React, { useState } from 'react';
import SubMenuItem from './SubMenuItem';

const MenuItem = ({ item }) => {
    const [isOpen, setIsOpen] = useState(false);
    const currentPath = window.location.pathname;
    const isParentActive = currentPath === item.link;
    const isChildActive = item.children.some(child => currentPath === child.link);
    const isActive = isParentActive || isChildActive;
    return (
        <li className={`menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-87 qodef--hide-link qodef-menu-item--narrow
             ${isActive ? "current-menu-ancestor current-menu-parent" : ""}
            `}
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
            >
            <a href={item.link}
            //  onClick={(e) => e.preventDefault()}
             >
                <span className="qodef-menu-item-text">
                    {item.text}
                    {item.children?.length > 0 && (
                        <svg className="qodef-svg--menu-arrow qodef-menu-item-arrow" xmlns="http://www.w3.org/2000/svg" width="12.643" height="12.642" viewBox="0 0 12.643 12.642">
                            <g fill="none" stroke="currentColor">
                                <path d="m5.968.353 5.968 5.968-5.968 5.967"/>
                                <path d="M11.935 6.32H0"/>
                            </g>
                        </svg>
                    )}
                </span>
            </a>
            {item.children?.length > 0 && (
                  <div className={`qodef-drop-down-second ${isOpen ? 'qodef-drop-down--start' : ''}`} style={{height:isOpen?"204px":"0px"}}>
                    <div className="qodef-drop-down-second-inner">
                        <ul className="sub-menu">
                            {item.children.map(child => (
                                <SubMenuItem key={child.id} item={child}/>
                                // <MenuItem key={child.id} item={child} />
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </li>
    );
};

export default MenuItem;